import { useResolvedDesignSystemComponent } from 'ext-ui/design-system/DesignSystemChannel'
import GeneratedLatestCheckbox, {
  CheckboxProps as GeneratedLatestCheckboxProps,
} from 'ext-ui/design-system/generated/latest/components/Checkbox/Checkbox'
import GeneratedLiveCheckbox, {
  CheckboxProps as GeneratedLiveCheckboxProps,
} from 'ext-ui/design-system/generated/live/components/Checkbox/Checkbox'
import React, { ReactElement } from 'react'

import { CheckboxProps } from './CheckboxLegacy'

function LiveCheckbox(props: CheckboxProps): ReactElement {
  const {
    defaultChecked: _defaultChecked,
    isInvalid = false,
    isPartial = false,
    ...rest
  } = props

  return (
    <GeneratedLiveCheckbox
      {...(rest as Omit<GeneratedLiveCheckboxProps, 'error' | 'indeterminate'>)}
      data-design-system-channel="live"
      error={isInvalid}
      indeterminate={isPartial}
    />
  )
}

function LatestCheckbox(props: CheckboxProps): ReactElement {
  const { isInvalid = false, isPartial = false, ...rest } = props

  return (
    <GeneratedLatestCheckbox
      {...(rest as Omit<
        GeneratedLatestCheckboxProps,
        'error' | 'indeterminate'
      >)}
      data-design-system-channel="latest"
      error={isInvalid}
      indeterminate={isPartial}
    />
  )
}

function Checkbox(props: CheckboxProps): ReactElement {
  const ResolvedCheckbox = useResolvedDesignSystemComponent(
    LiveCheckbox,
    LatestCheckbox,
  )

  return <ResolvedCheckbox {...props} />
}

export default Checkbox
export type { CheckboxProps }
